import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Nav, NavDropdown } from "react-bootstrap";
import { FaUserCircle, FaTachometerAlt, FaSignOutAlt, FaBars } from "react-icons/fa";
import { useAuth } from "../context/AuthContext";

const CustomNavbar = ({ onMenuClick }) => {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    setUser(null);
    navigate("/");
    window.location.reload();
  };

  return (
    <nav
      className="navbar d-flex justify-content-between align-items-center px-3"
      style={{ backgroundColor: "var(--forest)", padding: "0.5rem 1rem" }}
    >
      {/* Left side: Hamburger + Logo */}
      <div className="d-flex align-items-center">
        {user && (
          <button
            onClick={onMenuClick}
            className="btn btn-outline-light me-2 d-md-none"
          >
            <FaBars />
          </button>
        )}
        <Link to="/" className="navbar-brand text-white fs-4 m-0">
          GLM
        </Link>
      </div>

      {/* Right side: Login or User Icon */}
      <div className="d-flex align-items-center">
      {!user ? (
  <>
    <Link to="/login" className="nav-link text-white me-3">
      Login
    </Link>
    <Link to="/register" className="nav-link text-white">
      Register
    </Link>
  </>
) : (
          <Nav>
            <NavDropdown
              title={<FaUserCircle size={28} className="text-white" />}
              id="user-dropdown"
              align="end"
              menuVariant="light"
              className="no-caret"
            >
              <NavDropdown.Item as={Link} to="/dashboard">
                <FaTachometerAlt className="me-2" /> Dashboard
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/">Home</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="#">Change Password</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item onClick={handleLogout} className="text-danger">
                <FaSignOutAlt className="me-2" /> Logout
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        )}
      </div>
    </nav>
  );
};

export default CustomNavbar;

